const getReferringMedium = () => {
    const query = new URLSearchParams(window.location.search);
    return query.has('utm_medium') ? query.get('utm_medium').toLowerCase() : '';
};

export const isAmpReferrer = () => document.referrer.match(/\/amp\//g) !== null;

export const isEmailReferrer = () => {
    return getReferringMedium() === 'email';
};

export const isPlaReferrer = () => {
    const query = new URLSearchParams(window.location.search);
    return getReferringMedium() === 'pla' || (query.has('product') && query.has('gclid'));
};
